import React from "react";

interface ChildrenCommentsBadgeProps {
    label?: string;
}

const ChildrenCommentsBadge: React.FC<ChildrenCommentsBadgeProps> = ({ label }) => {
    return (
        <span
            className="ml-1 px-1 py-0.5 rounded bg-blue-200 text-blue-800 font-semibold text-sm relative"
            style={{ top: '-5px', fontSize: '0.7rem' }}
        >
            {label}
        </span>
    );
};

export default ChildrenCommentsBadge;
